import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const RadioFilled = ({ size = 34, style }: IconProps) => {
  const { theme } = useTheme();

  return (
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none" style={style}>
      <rect
        x="6"
        y="6"
        width="22"
        height="22"
        rx="11"
        fill={theme.background}
        stroke={theme.icon.default}
        strokeWidth="2"
      />
      <circle cx="17" cy="17" r="8" fill={theme.icon.default} />
    </svg>
  );
};
